import React from "react";

const DashboardPrincipal = () => {
  return (
    <section
      className="min-h-screen flex flex-col items-center justify-center p-4"
      style={{
        backgroundImage: 'url("/images/bg-hotel.jpg")',
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div
        className="bg-white shadow-2xl rounded-lg max-w-4xl w-full p-8 opacity-95"
        style={{ boxShadow: "0 20px 40px rgba(0,0,0,0.3)" }}
      >
        <div className="text-center mb-8">
          <h2 className="text-4xl font-extrabold text-green-700 uppercase">
            Bienvenido a la Posada
          </h2>
          <p className="text-gray-600 mt-4 text-lg leading-relaxed">
            La aplicación de gestión de posada te ayuda a llevar un control
            integral y efectivo de tus operaciones. Desde la administración de
            clientes hasta la reserva de apartamentos, tendrás acceso a una
            vista clara y organizada de todo lo que necesitas.
          </p>

          {/* Imagen de bienvenida */}
          <div className="flex justify-center mt-6">
            <img
              src="/posada_imagen.jpg"
              alt="Imagen de la Posada"
              className="rounded-lg shadow-xl w-full max-w-md" // max-w-md hace la imagen un poco más pequeña y compacta
            />
          </div>

          <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-8 text-left">
            <div className="bg-green-100 p-6 rounded-lg shadow-md">
              <h3 className="text-2xl font-semibold text-green-800 mb-4">
                Gestión de Clientes
              </h3>
              <p className="text-gray-600">
                Agrega y gestiona información detallada de tus clientes. Accede
                a sus datos, edita sus perfiles y organiza tus registros.
              </p>
            </div>

            <div className="bg-green-100 p-6 rounded-lg shadow-md">
              <h3 className="text-2xl font-semibold text-green-800 mb-4">
                Registro de Reservas
              </h3>
              <p className="text-gray-600">
                Controla las reservas de apartamentos de manera eficiente,
                registrando fechas de inicio y fin y verificando la
                disponibilidad en tiempo real.
              </p>
            </div>

            <div className="bg-green-100 p-6 rounded-lg shadow-md">
              <h3 className="text-2xl font-semibold text-green-800 mb-4">
                Calendario Interactivo
              </h3>
              <p className="text-gray-600">
                Visualiza la disponibilidad de apartamentos en un calendario
                claro e interactivo. Consulta y organiza las reservas de manera
                intuitiva.
              </p>
            </div>
          </div>

          <p className="text-gray-600 mt-8 text-lg leading-relaxed">
            Explora las distintas funcionalidades a través del menú lateral.
            Podrás acceder rápidamente a la gestión de clientes, al registro de
            reservas y al calendario de disponibilidad, asegurando una
            administración fluida y organizada de la posada.
          </p>
        </div>
      </div>
    </section>
  );
};

export default DashboardPrincipal;
